<!-- =========================================================================================
    File Name: Login.vue
    Description: Login Page
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
  <div id="login">
    <div class="w-full h-screen bg-img">
      <login-navbar />

      <div class="vx-row mt-16 items-center justify-center">
        <div
          class="vx-col sm:w-1/2 md:w-1/2 lg:w-3/4 xl:w-3/5 sm:m-0 m-4 mx-auto items-center justify-center"
        >
          <vx-card>
            <div slot="no-body" class="full-page-bg-color">
              <div class="vx-row justify-center items-center">
                <div class="vx-col hidden lg:block lg:w-1/2">
                  <img
                    src="@/assets/images/pages/login.png"
                    alt="login"
                    class="mx-auto"
                  />
                </div>

                <div
                  class="vx-col sm:w-full md:w-full lg:w-1/2 d-theme-dark-bg"
                >
                  <div class="px-8 pt-8 login-tabs-container mt-10">
                    <div class="vx-card__title">
                      <h4 class="mb-4">Login</h4>
                      <p>Welcome back, please login to your account.</p>
                    </div>

                    <login-firebase class="mt-5"></login-firebase>
                  </div>
                </div>
              </div>
            </div>
          </vx-card>
        </div>
      </div>
    </div>
    <the-footer />
  </div>
</template>


<script>
import LoginFirebase from "./LoginFirebase.vue";
import LoginNavbar from "@/layouts/components/navbar/loginnavbar.vue";
import TheFooter from "@/layouts/components/TheFooter.vue";
export default {
  components: {
    LoginFirebase,
    LoginNavbar,
    TheFooter,
  },
};
</script>

<style lang="scss">
.login-tabs-container {
  min-height: 405px;

  .con-tab {
    padding-bottom: 14px;
  }

  .con-slot-tabs {
    margin-top: 1rem;
  }
}
.h-screen {
  height: 95vh !important;
}
</style>
